import React from 'react'
import { useEffect, useState } from 'react';
import './Main.css';
import ContentWrapper from 'shared/components/ContentWrapper';
import Sidebar from 'shared/components/Sidebar';
import '@devexpress/dx-react-grid-bootstrap4/dist/dx-react-grid-bootstrap4.css';

interface MainLayoutProps {
    showOverlay?: boolean
    headerInsert?: React.FunctionComponent | React.ReactElement | false 
    actionInsert?: React.FunctionComponent | React.ReactElement | false
    brandContent?: React.FunctionComponent | React.ReactElement | string | false
    footerContent?: React.FunctionComponent | React.ReactElement | string | false
    showCardHeader?: boolean
    showMinimizedBarButton?: boolean
    noCard?: boolean
    minimizedBar?: boolean
}

const MainLayout: React.FunctionComponent<MainLayoutProps> = (props) => {
    
    const children:any = React.Children.only(props.children)
    const [wrapperClasses, setWrapperClasses] = useState<string>('')

    useEffect(() => {
        const classes = props.minimizedBar ? ' minimized-bar' : '' 
        setWrapperClasses(classes)
    }, [props.minimizedBar])

    return (
        <div className={"wrapper" + wrapperClasses}>
            <Sidebar 
                brandContent={props.brandContent} 
                showMinimizeBarButton={props.showMinimizedBarButton}
            />
            <ContentWrapper 
                headerInsert={props.headerInsert} 
                actionInsert={props.actionInsert} 
                footerContent={props.footerContent} 
                showCardHeader={props.showCardHeader}
                noCard={props.noCard}
            >
                {React.cloneElement(children)}
                {props.showOverlay && <div className="main-overlay">
                    <img src="/images/loading.svg" alt="loading" />
                </div>}
            </ContentWrapper>
        </div>
    );
}

export default MainLayout